import { Download, Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import DataTable from '@/components/DataTable';
import Pagination from '@/components/Pagination';
import AppliedFilters from '@/components/AppliedFilters';

/**
 * Patrón repetido en los tabs de movimientos, recolecciones, entregas y alistamientos:
 * → AppliedFilters (si hay filtros activos)
 * → Barra de acciones (Exportar + Filtros)
 * → DataTable
 * → Pagination
 *
 * Props:
 *  filters, filterFields, onRemoveFilter — para AppliedFilters
 *  onOpenFilterDrawer — abre el drawer de filtros
 *  onExport — opcional; si se pasa muestra el botón Exportar
 *  columns, data, isLoading — para DataTable
 *  hideActionsColumn, showDefaultActions — pasan directo a DataTable
 *  currentPage, totalItems, itemsPerPage, onPageChange — para Pagination
 */
const TabConFiltros = ({
  filters = {},
  filterFields = [],
  onRemoveFilter,
  onOpenFilterDrawer,
  onExport,
  columns,
  data,
  isLoading,
  hideActionsColumn = false,
  showDefaultActions,
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  const activeCount = Object.keys(filters).filter(
    (k) => filters[k] !== undefined && filters[k] !== null && filters[k] !== '',
  ).length;

  const tableProps = {
    columns,
    data,
    isLoading,
    hideActionsColumn,
    ...(showDefaultActions !== undefined && { showDefaultActions }),
  };

  return (
    <>
      {activeCount > 0 && (
        <AppliedFilters
          filters={filters}
          onRemoveFilter={onRemoveFilter}
          filterFields={filterFields}
        />
      )}

      <div className="flex items-center justify-end gap-4">
        {onExport && (
          <Button variant="outline" onClick={onExport} className="flex items-center gap-2">
            <Download className="h-4 w-4" />
            Exportar
          </Button>
        )}
        <Button variant="outline" onClick={onOpenFilterDrawer} className="flex items-center gap-2">
          <Filter className="h-4 w-4" />
          Filtros
          {activeCount > 0 && (
            <Badge variant="secondary" className="ml-1">
              {activeCount}
            </Badge>
          )}
        </Button>
      </div>

      <DataTable {...tableProps} />

      <Pagination
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        onPageChange={onPageChange}
      />
    </>
  );
};

export default TabConFiltros;
